// web/src/notifications/initNotifications.js
import { LocalNotifications } from '@capacitor/local-notifications';
import { isNative } from '../utils/platform';
export async function initAndroidChannels() {
  if (!isNative()) return; // avoid "Not implemented on web."
  try {
    await LocalNotifications.requestPermissions(); // Android OK
    await LocalNotifications.createChannel({
      id: 'chat', name: 'Chat',
      description: 'New chat messages', importance: 4, sound: 'default', visibility: 1
    });
    await LocalNotifications.createChannel({
      id: 'waiting', name: 'Participants Waiting',
      description: 'Lobby/admission alerts', importance: 4
    });
    await LocalNotifications.createChannel({
      id: 'calls', name: 'Calls',
      description: 'Incoming/missed calls', importance: 5
    });
    // Updates badge/notification க்கு தனி channel
    await LocalNotifications.createChannel({
      id: 'updates',
      name: 'App Updates',
      description: 'New version available',
      importance: 4,
    });
  } catch (e) { console.warn('Channel init error', e); }
}
